import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@base/base.component';
import { PortfolioActives } from '@enums/portfolio-actives';
import { DateHelper } from '@helpers/data-helper';
import { ListPortfolioManagementCountQuery, ListPortfolioManagementCountQueryResponse } from '@models/reports/reports';
import { KeyValueOptions } from '@models/settings/settings';
import { ReportsService } from '@services/reports.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-summary-contemplated-quotas',
  templateUrl: './summary-contemplated-quotas.component.html',
  styleUrl: './summary-contemplated-quotas.component.scss'
})

export class SummaryContemplatedQuotasComponent extends BaseComponent implements OnInit {

  public portfolioSummary: ListPortfolioManagementCountQueryResponse[] = [];
  public startDate: Date;
  public endDate: Date;
  public chartData: number[] = [];
  public chartLabelsX: string[] = [];
  public isLoading: boolean = false;

  public readonly activesOptions: KeyValueOptions[] = [
      {
        key: 'Ativos contemplados com bens entregues',
        value: PortfolioActives.AssetsContemplatedWithAssetsDelivered 
      },
      {
        key: 'Contemplações no mês - quantidade de cotas',
        value: PortfolioActives.ContemplationsInTheMonth
      },
    ];

  public constructor(private readonly _reportsService: ReportsService) {
      super();
    }
    
  public ngOnInit() {
  
    this.startDate = DateHelper.yearsAgo(DateHelper.currentDate, 4);
    this.endDate = DateHelper.currentDate;
      
    this.filter();
    
  }

  public filter(): void {
  
    let params: ListPortfolioManagementCountQuery = {
      actives: this.activesOptions.map(option => option.value),
      identifierCode: this.getAccessPoint().identifierCode,
      initialDate: this.startDate,
      endDate: this.endDate
    };
    
    this.isLoading = true;

    firstValueFrom(
      this._reportsService.getPortfolioSummary(params)
    )
    .then((resp: any) => {
      this.portfolioSummary = resp;
      this.chartData = this.portfolioSummary.map(option => option.activesCount);
      this.chartLabelsX = this.portfolioSummary.map(option => option.name);
    })
    .finally(() => {
      this.isLoading = false;
    });
  }
}
